/*
    created by jl - 2018-02-13
*/

/*
 getCookie("cookie-name-here");
 name: string
 */
//TODO: Change this to "getCookieByName(name)"
//TODO: move all cookie strings into an array here and give them human-readable alternatives that can be called in the functions i.e. "getCookieByName('geo-location')"
function getCookie(name) {
    var array = document.cookie.split(";");

    for (var i = 0; i < array.length; i++) {
        var parts = array[i].split('=');

        if (parts.length == 2 && parts[0].trim() == name) {
            return  parts[1].replace(/[^a-z0-9,]/gi, "");
        }
    }

    return false;
}

/*
 setCookie("cookie-name-here", "cookie-value-here", cookie-expiry-here, "operation-here");
 name: string
 value: string
 expiry: integer (in days. 0 which means no expiry)
 operation: string | can be append, delete or overwrite. default is overwrite
 */
function setCookie(name, value, expiry, operation) {
    var date = new Date();
    var expires;
    var path = "; path=/";
    var gdpr_opt_in_cookie_name = "gdpr_opted_in";

    var cookie;

    //accepts only alphanumeric values
    value = value.replace(/[^a-z0-9,]/gi, "");

    if (name.trim().length > 0 && value.trim().length > 0) {
        switch (operation) {
            case "append":
                cookie = name + "=" + appendValueToCookie(name, value);

                break;
            case "delete":
                cookie = name + "=" + deleteValueFromCookie(name, value);

                break;
            default:
                cookie = name + "=" + value;

                break;
        }

        if (expiry != null && expiry > 0) {
            date.setTime(date.getTime() + (expiry * 24 * 60 * 60 * 1000));

            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        if(!checkCookiesForOptIn(gdpr_opt_in_cookie_name)) {
            console.log("Warning: Opt-in not accepted, so cookie will not be persisted!", name);
            //Do some closure magic to keep the value of expires BEFORE we change it
            var setCookie = (function(inner_expires){ return function(){
                //console.log("Setting cookie "+name+" to "+value+" post GDPR opt in! expires: "+inner_expires);
                document.cookie = cookie + inner_expires + path;
            } })(expires);
            RegisterPostGDPRHook(setCookie);
            expires = "; expires=Thu, 01-Jan-1970 00:00:01 GMT";
        }

        document.cookie = cookie + expires + path;

        return {code:1, message:"success", name: name, value: value, action: operation};
    } else {
        return {code:0, message:"cookie name/value are not available"};
    }
}

function appendValueToCookie(name, value) {
    var currentCookie = getCookie(name);

    if (currentCookie.length > 0) {
        if (currentCookie.split(",").indexOf(value) == -1) {
            return currentCookie + "," + value;
        } else {
            return currentCookie;
        }
    }

    return value;
}

function deleteValueFromCookie(name, value) {
    var currentCookie = getCookie(name);

    if (currentCookie.length > 0) {
        return currentCookie.replace(value, "").replace(/^,/, "").replace(/,$/, "").replace(",,", ","); //extra replace removes leading/ending comma and double commas
    }
}
